<!-- 首页 -->
<template>
  <div ref="home" class="home">
    <payPage ref="pay"></payPage>
    <!-- <canvas id="canvas"></canvas> -->
    <!-- banner图部分 -->
    <!-- 移动端轮播图 -->
    <swiper :options="swiperOptions" v-if="bannerArr.length > 0">
      <swiper-slide v-for="(item,index) in bannerArr" :key="index">
        <div class="blockText animate__animated animate__zoomIn">
          <h4>{{ item.title }}</h4>
          <h5><pre>{{ item.subtitle }}</pre></h5>
          <a href="javascript:void(0);" class="comButton collection-1 btn-15">
            <span v-if="!item.id" @click="toPlan(item)">免费申请试用</span>
            <span v-else @click="toInfo(item)">查看详情</span>
          </a>
        </div>
        <img ref="swiperImg" :src="item.sliderImg" alt />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <!-- pc端轮播图 -->
    <div class="block">
      <el-carousel height="100vh" class="el-carousel_pc" arrow="always">
        <el-carousel-item v-for="(item,index) in bannerArr" :key="index">
          <h3 class="small">
            <div class="blockText animate__animated animate__zoomIn">
              <h4>{{ item.title }}</h4>
              <h5><pre>{{ item.subtitle }}</pre></h5>
              <a href="javascript:void(0);" class="comButton collection-1 btn-15">
                <span v-if="!item.id" @click="toPlan(item)">免费申请试用</span>
                <span v-else @click="toInfo(item)">查看详情</span>
              </a>
            </div>
            <img :src="item.sliderImg" alt />
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 解决方案 -->
    <div>
      <div class="currencyTitle">
        <img src="../assets/images/logoTitle.png" alt />
        <h3>我们提供全面的解决方案</h3>
      </div>
      <div class="styleBox_05">
        <div class="tipsBoxWall">
          <ul class="tipsBox">
            <li
              v-for="(items,keys) in solveArr"
              :key="keys"
              :class="items.tagsChecked ? 'checked' : ''"
              @click="changeTags(keys)"
              :style="viewWidth >= 1024 ? (solveArr.length <= 5 ? 'maxWidth:' +  1180 / solveArr.length + 'px' : 'minWidth:' + 1180 / 5 + 'px' ) : ('minWidth:' + viewWidth / 3 + 'px')"
            >
              <p class="tipNum">0{{ keys + 1}}</p>
              <span><a href="javascript:;" :title="items.title">{{ items.title }}</a></span>
            </li>
          </ul>
        </div>
        <div
          v-for="(items,keys) in solveArr"
          :key="keys"
          v-show="items.tagsChecked"
          :class="items.tagsChecked ? 'animate__animated animate__fadeInLeft' : ''"
        >
          <!-- <div v-html="items.content"></div> -->
          <div class="tipsInner" :style="{backgroundImage:'url('+ bgUrl +')'}">
            <div class="tipsInnerWidth">
              <div class="tipInnerImg">
                <img :src="items.coverImage" />
              </div>
              <div class="tipInnerText">
                <h4>{{ items.title }}</h4>
                <div class="icon_01"></div>
                <p>{{ items.descriptionStr }}</p>
                <ul>
                  <li v-for="itemi in items.descriptionArr" :key="itemi">{{ itemi }}</li>
                </ul>
                <div class="btnBox">
                  <a href="javascript:void(0);" class="comButton collection-1 btn-15">
                    <span @click="toSolveInfo(items)">了解更多 →</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="numberTips">
          <span
            v-for="(items,keys) in solveArr"
            :key="keys"
            :class="items.tagsChecked ? 'spanCheck':''"
          ></span>
        </div>
      </div>
    </div>
    <!-- 主题 文章 模块 -->
    <div style="overflow:hidden;">
      <div
        class="innerBox wow animate__animated animate__fadeInUp"
        v-for="(item,index) in moudleArr"
        :key="index"
      >
        <div class="currencyTitle" v-if="item.title">
          <img :src="item.coverImage" alt />
          <h3>{{ item.title }}</h3>
        </div>
        <div v-html="item.content" v-if="!item.tagsArr"></div>
        <!-- <div v-else>
          <div class="styleBox_05">
            <div class="tipsBoxWall">
              <ul class="tipsBox">
                <li
                  v-for="(items,keys) in item.tagsArr"
                  :key="keys"
                  :class="items.tagsChecked ? 'checked' : ''"
                  @click="changeTags(index,keys)"
                  :style="viewWidth >= 1024 ? (item.tagsArr.length <= 5 ? 'maxWidth:' +  1180 / item.tagsArr.length + 'px' : 'minWidth:' + 1180 / 5 + 'px' ) : ('minWidth:' + viewWidth / 3 + 'px')"
                >
                  <p class="tipNum">0{{ keys + 1}}</p>
                  <span>{{ items.title }}</span>
                </li>
              </ul>
            </div>
            <div
              v-for="(items,keys) in item.tagsArr"
              :key="keys"
              v-show="items.tagsChecked"
              :class="items.tagsChecked ? 'animate__animated animate__fadeInLeft' : ''"
            >
              <div v-html="items.content"></div>
            </div>
            <div class="numberTips">
              <span
                v-for="(items,keys) in item.tagsArr"
                :key="keys"
                :class="items.tagsChecked ? 'spanCheck':''"
              ></span>
            </div>
          </div>
        </div>-->
      </div>
    </div>
    <!-- 新闻资讯 -->
    <div class="wow animate__animated animate__fadeInUp">
      <div class="currencyTitle">
        <img :src=" baseImgUrl + '/u/20230102/编组@2x_1672629041546.png'" alt />
        <h3>新闻与资讯</h3>
      </div>
      <!-- pc端新闻资讯 -->
      <div class="styleBox_06">
        <img class="news_bg" src="../assets/images/img_news.jpg" alt />
        <ul>
          <li
            v-show="index < 3"
            v-for="(item,index) in newsArr"
            :key="index"
            @click="getInfo(item)"
            @mouseenter="hoverNews(index)"
            @mouseleave="outNews()"
          >
            <img :src="item.coverImage" />
            <h4>{{ item.title }}</h4>
            <p>{{ item.description.split('@')[0] }}</p>
            <div>
              <span>{{ item.releaseDate }}</span>
              <img v-if="item.charge === 0" :src="item.hover ? img_more02 : img_more01" />
              <span v-else>付费信息2元/条</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- 移动端新闻资讯 -->
      <el-carousel class="newsBg" :interval="4000" type="card" height="22.8rem">
        <el-carousel-item v-for="(item,index) in newsArr" :key="index">
          <div
            class="newBanner"
            @click="getInfo(item)"
            @mouseenter="hoverNews(index)"
            @mouseleave="outNews()"
          >
            <img class="bannerImg" :src="item.coverImage" />
            <h4>
              <span>{{ item.title }}</span>
            </h4>
            <p>{{ item.description }}</p>
            <div class="newFooter">
              <span>{{ item.releaseDate }}</span>
              <img v-if="item.charge === 0" :src="item.hover ? img_more02 : img_more01" />
              <span v-else>付费信息2元/条</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 底部新闻 查看更多 -->
    <div class="moreService">
      <a @click="toNews()" href="javascript:void(0);" class="comButton collection-1 btn-15">
        <span>查看更多</span>
      </a>
    </div>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
import payPage from '@/components/comForPc/payPage.vue'
// import start from '@/utils/canvas'
import { WOW } from 'wowjs'
export default {
  components: { Header, Sidebar, Footer, payPage },
  data () {
    return {
      moudleArr: [], // 文章数据集合
      newsArr: [], // 新闻数据集合
      solveArr: [], // 解决方案数据集合
      viewHeight: 0, // 屏幕高度
      img_more01: require('../assets/images/img_more01.png'),
      img_more02: require('../assets/images/img_more02.png'),
      bannerArr: [], // 轮播图数据集合
      imgHeight: '', // 轮播图高度
      viewWidth: '', // 屏幕宽度
      tipsBoxWidth: '', // 计算解决方案 切换模块宽度
      swiperOptions: { // 移动轮播图配置
        autoplay: 3000,
        speed: 1000,
        // loop: true,
        pagination: '.swiper-pagination'
      },
      baseImgUrl: '',
      bgUrl: ''
    }
  },
  methods: {
    // 获取首页文章
    getHomeId (arr) {
      let modelArr = []
      JSON.parse(arr).forEach(item => {
        if (item.id === 1) {
          modelArr = item.articleList
        }
        if (item.id === 5) {
          item.articleList.forEach(item => {
            item.hover = false
            if(item.releaseDate){
              item.releaseDate = item.releaseDate.split(' ')[0]
            }
          })
          this.newsArr = item.articleList
        }
        if (item.id === 3) {
          item.articleList.forEach(items => {
            items.tagsChecked = false
            items.path = item.path
            if (items.description && (items.description.indexOf('@') !== -1)) {
              let arr = items.description.split('@')
              items.descriptionStr = arr[0]
              arr.shift()
              items.descriptionArr = arr
            }
          })
          item.articleList[0].tagsChecked = true
          this.solveArr = item.articleList
          console.log(this.solveArr)
        }
      })
      let haveTags = false
      let tagsArr = []
      let modelArrNew = []
      modelArr.forEach(item => {
        if (item.tags && item.tags.length > 0) {
          item.tags.forEach(items => {
            if (items.name === 'homeTabs') {
              item.tagsText = 'homeTabs'
              tagsArr.push(item)
            }
            if (!haveTags) {
              item.tagsIndex = 0
              haveTags = true
            }
          })
        }
      })
      modelArr.forEach((item, index) => {
        if (item.tagsText && item.tagsText === 'homeTabs' && item.tagsIndex === 0) {
          tagsArr.forEach(items => {
            items.tagsChecked = false
          })
          tagsArr[0].tagsChecked = true
          item.tagsArr = tagsArr
        }
      })
      modelArr.forEach((item, index) => {
        if (!item.tagsText) {
          modelArrNew.push(item)
        }
        if (item.tagsText && item.tagsText === 'homeTabs' && item.tagsArr) {
          modelArrNew.push(item)
        }
      })
      this.moudleArr = modelArrNew
      this.wowInit()
    },
    // 滚动到相应位置 注册animate动画
    wowInit () {
      // wow初始化
      this.$nextTick(() => {
        const wow = new WOW({
          boxClass: 'wow', // default
          animateClass: 'animated', // default
          offset: 150, // default
          mobile: true, // default
          live: false,
          // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.
          callback: function (box) {
            console.log('WOW: animating <' + box.tagName.toLowerCase() + '>')
          }
        })
        wow.init()
      })
    },
    // 解决方案 点击
    changeTags (indexs) {
      this.solveArr.forEach(item => {
        item.tagsChecked = false
      })
      this.solveArr[indexs].tagsChecked = true
    },
    // 解决方案 点击 了解更多
    toSolveInfo (item) {
      this.$router.push({ path: item.path, query: { id: item.categoryId, childId: item.id } })
    },
    // 点击 滚动一屏
    goDown () {
      window.scrollTo({
        top: this.viewHeight - 64,
        left: 0,
        behavior: 'smooth'
      })
    },
    // 跳转到 获取方案页面
    toPlan () {
      this.$router.push('/getPlan')
    },
    // 底部 查看更多 跳转到新闻咨询列表
    toNews () {
      this.$router.push({ path: '/news', query: { id: 5 } })
    },
    // 新闻资讯 跳转到详情页面
    getInfo (data) {
      if (data.charge === 0) {
        this.$router.push({ path: '/newsInfo', query: { id: data.id } })
      } else {
        this.$refs.pay.showDialog()
      }
    },
    // 新闻资讯 鼠标悬浮效果 移入
    hoverNews (index) {
      this.newsArr.forEach(item => {
        item.hover = false
      })
      this.newsArr[index].hover = true
    },
    // 新闻资讯 鼠标悬浮效果 移出
    outNews () {
      this.newsArr.forEach(item => {
        item.hover = false
      })
    },
    // 获取轮播图图片集合
    getBannerImg () {
      this.$axios.get('/blog/api/getarticlebyslider')
        .then(res => {
          res.data.unshift({
            title: '新一代网络架构和NaaS创新领航者',
            // subtitle: '提供合规和智能化网络服务为互联网应用稳定运行保驾护航',
            sliderImg: require('../assets/images/banner.jpg')
          })
          this.bannerArr = res.data
          this.bannerArr.forEach(item => {
            if (item.description && (item.description.indexOf('@') !== -1)) {
              let arr = item.description.split('@')
              item.description = arr[0]
            }
          })
          this.imgLoad()
        }).catch(err => {
          console.log(err)
        })
    },
    // 获取banner图第一张图片的高度 适配移动端轮播图
    imgLoad () {
      if (this.bannerArr.length > 0) {
        let _self = this
        setTimeout(function () {
          _self.$nextTick(() => {
            _self.imgHeight = _self.$refs.swiperImg[0].height
          })
        }, 400)
      }
    },
    // 轮播图 跳转到
    toInfo (item) {
      if (item.charge !== 0) {
        this.$refs.pay.showDialog()
        return
      }
      // 新闻详情
      if (item.path === '/news') {
        this.$router.push({ path: '/newsInfo', query: { id: item.id } })
      }
      // 配置页面
      this.$router.push({ path: item.path, query: { id: item.categoryId, childId: item.id } })
    },
    // 当窗口宽度发生改变
    changeViewWidth () {
      this.viewWidth = document.documentElement.clientWidth || document.body.clientWidth
      // if (this.viewWidth >= 1180) {
      //   this.tipsBoxWidth = 1180 /
      // } else {
      //   this.tipsBoxWidth = this.viewWidth / 3
      // }
    }
  },
  created () {
    this.viewHeight = document.documentElement.clientHeight || document.body.clientHeight
    this.viewWidth = document.documentElement.clientWidth || document.body.clientWidth
    this.baseImgUrl = this.$axios.defaults.baseURL
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230102/plan_1672628507168.jpg'
    this.getBannerImg()
    this.getHomeId(localStorage.getItem('navList'))
  },
  mounted () {
    // canvas初始化
    // start()
    window.onresize = () => {
      this.imgLoad()
      this.changeViewWidth()
    }
  },
  computed: {
    mySwiper () {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>
<style lang="less" scoped>
.swiper-image {
  width: 100%;
  height: 270px;
}
// 移动端样式
@media only screen and (max-width: 1024px) {
  .home {
    padding-top: 2.75rem;
    overflow-x: hidden;
  }
  // 按钮样式
  .comButton {
    padding: 0.9375rem 2.25rem;
    color: #fff;
    border-radius: 1.75rem;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    height: 2.5rem;
    font-size: 0.7rem;
    max-width: 9rem;
  }
  .moreService {
    text-align: center;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
  .el-carousel_pc {
    display: none;
  }
  // 轮播图样式
  .currencyTitle {
    display: flex;
    justify-content: center;
    margin: 2rem 0 2rem 0;
    img {
      width: 1.75rem;
      height: 1.55rem;
    }
    h3 {
      color: #08142a;
      font-size: 1rem;
      font-weight: bold;
      margin-left: 1rem;
    }
  }
  .styleBox_05 {
    width: 100%;
    .tipsBox {
      box-shadow: 0px 4px 8px -3px rgba(0, 0, 0, 0.3);
      // height: 6.25rem;
      display: flex;
      position: relative;
      z-index: 9;
      overflow-x: scroll;
      width: 100%;
      overflow-x: scroll;
      li {
        width: 33.3%;
        font-size: 0.875rem;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        cursor: pointer;
        flex: 1;
        padding: 0.75rem 1.56rem;
        line-height: 1.6rem;
        .tipNum {
          color: #90bff7;
          font-size: 1rem;
        }
      }
      .checked {
        background-image: linear-gradient(
          228deg,
          rgba(62, 227, 255, 1),
          rgba(46, 158, 253, 1) 62%,
          rgba(24, 106, 232, 1)
        );
        color: #fff;
      }
    }
    .numberTips {
      display: flex;
      justify-content: center;
      span {
        width: 1.5rem;
        height: 0.25rem;
        border-radius: 0.125rem;
        background: #d6dfed;
        margin-right: 0.5rem;
        margin-top: 1.43rem;
      }
      span:last-child {
        margin-right: 0;
      }
      .spanCheck {
        background: #428bf8;
      }
    }
  }
  .newsBg {
    background: url('../assets/images/img_news.jpg') no-repeat;
    padding-top: 9.5rem;
    background-size: 100% 91%;
    .el-carousel__item {
      box-shadow: 0px 4px 8px -3px rgba(0, 0, 0, 0.3);
      border-radius: 0.5rem;
      overflow: hidden;
    }
  }
  /deep/ .newBanner {
    background: #fff;
    height: 100%;
    img {
      transform: none;
      left: 0;
      top: 0;
      position: relative;
      min-width: auto;
    }
    .bannerImg {
      width: 100%;
    }
    h4 {
      padding: 1.25rem 1.25rem 0.625rem;
      font-size: 1rem;
      font-weight: 600;
      color: #353535;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    p {
      padding: 0 1.25rem 0;
      font-size: 0.875rem;
      font-weight: 300;
      color: #4c5461;
    }
    .newFooter {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1.1875rem 0;
      position: absolute;
      bottom: 1rem;
      width: 100%;
      img {
        width: 1.175rem;
        float: right;
      }
      span {
        font-size: 0.8125rem;
        font-weight: 300;
        color: #6f788c;
      }
    }
  }
  .styleBox_06 {
    display: none;
  }
  .swiper-container {
    position: relative;
  }
  .swiper-pagination {
    width: 100%;
  }
  .swiper-pagination-bullet {
    margin: 0 0.5rem;
  }
  .swiper-slide {
    position: relative;
    img {
      width: 100%;
      width: 100%;
    }
    .blockText {
      padding-top: 2rem;
      position: absolute;
      z-index: 9;
      width: 100%;
      text-align: center;
      height: 100%;
      z-index: 3;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      h5 {
        color: #fff;
        max-width: 80%;
        font-size: .75rem;
        font-weight: normal;
        color: #ffffff;
        letter-spacing: 0.125rem;
        display:-webkit-box;
        text-align: center;
        pre{
          width: 100%;
          white-space: pre-wrap;
          word-wrap: break-word;
        }
      }
      h4 {
        font-size: 1.125rem;
        font-weight: bold;
        color: #ffffff;
        max-width: 80%;
        letter-spacing: 0.125rem;
        text-shadow: 0px 0.125rem 0.25rem rgba(0, 0, 0, 0.5);
        margin-bottom: 1.6875rem;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display:-webkit-box;
        // -webkit-box-orient:vertical;
        // -webkit-line-clamp:1;
      }
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .swiper-container {
    display: none;
  }
  .newsBg {
    display: none;
  }
  .home {
    width: 100%;
    background: #fff;
    // 按钮样式
    .comButton {
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      height: 50px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
    .el-carousel_mobile {
      display: none;
    }
    // 轮播图样式
    .el-carousel {
      position: relative;
      overflow: hidden;
      img {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        min-width: 100%;
        min-height: 100vh;
        transform: translate(-50%, -50%);
      }
      .blockText {
        position: relative;
        z-index: 9;
        height: 100vh;
        z-index: 3;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        h5 {
          font-size: 30px;
          color: #fff;
          margin-bottom: 100px;
          max-width: 1180px;
          font-weight: 100;
          text-align: center;
          pre{
            white-space: pre-wrap;
            word-wrap: break-word;
          }
        }
        h4 {
          font-size: 52px;
          color: #fff;
          margin-bottom: 48px;
          letter-spacing: 5px;
          text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
        }
      }
    }
    // 通用标题
    .currencyTitle {
      display: flex;
      justify-content: center;
      margin: 50px 0 85px 0;
      img {
        width: 69px;
        height: 54px;
      }
      h3 {
        color: #08142a;
        font-size: 32px;
        font-weight: bold;
        line-height: 45px;
        margin-left: 22px;
      }
    }
    .innerBox {
      width: 100%;
      overflow: hidden;
    }
    .styleBox_05 {
      width: 100%;
      .tipsBoxWall {
        box-shadow: 0px 4px 8px -3px rgba(0, 0, 0, 0.3);
        height: 90px;
        position: relative;
        z-index: 9;
      }
      .tipsBox {
        display: flex;
        max-width: 1180px;
        overflow-x: scroll;
        margin: 0 auto;
        outline: none;
        height: 100%;
        scrollbar-color: rgb(205, 205, 205);
        scrollbar-width: thin;
        -ms-overflow-style: none;
        li {
          padding: 19px 16px;
          font-size: 19px;
          font-weight: bold;
          display: flex;
          align-items: center;
          cursor: pointer;
          span{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
          .tipNum {
            color: #90bff7;
            font-size: 30px;
            margin-right: 12px;
          }
        }
        .checked {
          background-image: linear-gradient(
            228deg,
            rgba(62, 227, 255, 1),
            rgba(46, 158, 253, 1) 62%,
            rgba(24, 106, 232, 1)
          );
          color: #fff;
        }
      }
      .tipsBox::-webkit-scrollbar {
        width: 20px;
        height: 6px;
      }
      .tipsBox::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: rgb(205, 205, 205);
      }
      .tipsBox::-webkit-scrollbar-button {
        width: 0;
        border-radius: 50%;
        background: black;
      }
      .tipsBox::-webkit-scrollbar-track {
        // box-shadow: inset 0 0 2px #333;
        border-radius: 5px;
        background: rgba(0, 0, 0, 0);
      }
      .tipsBox::-webkit-scrollbar-corner {
        background: springgreen;
      }
    }
    .styleBox_07 {
      width: 100%;
      height: 320px;
      background: url('http://47.92.227.246:8081/u/20230101/img_gg_1672576300037.jpg')
        no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .styleBox_07 p {
      font-size: 32px;
      font-weight: 600;
      color: #08142a;
      margin-bottom: 44px;
    }
    .comButton {
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      padding: 0;
      height: 50px;
      font-size: 18px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
    .styleBox_06 {
      position: relative;
      padding-top: 154px;
      padding-bottom: 50px;
    }
    .styleBox_06 ul {
      position: relative;
      z-index: 9;
      max-width: 1180px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    .styleBox_06 ul li {
      width: 32%;
      box-shadow: 0px 2px 5px 0px rgba(204, 204, 204, 0.5);
      border-radius: 12px;
      overflow: hidden;
      transition: all 0.4s;
      -moz-transition: all 0.4s;
      -webkit-transition: all 0.4s;
      -o-transition: all 0.4s;
      border: 4px solid rgba(204, 204, 204, 0);
      box-sizing: border-box;
      background: #fff;
    }
    .styleBox_06 ul li:hover {
      transform: scale(1.05) translateY(-24px);
      border: 4px solid #428bf8;
      cursor: pointer;
    }
    .styleBox_06 ul li img {
      width: 100%;
    }
    .styleBox_06 ul li h4 {
      padding: 23px 30px 16px;
      font-size: 20px;
      font-weight: 600;
      color: #4c5461;
      height:78px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .styleBox_06 ul li p {
      height: 64px;
      font-size: 16px;
      font-weight: 300;
      color: #4c5461;
      padding: 0 30px 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      margin-bottom: 18px;
    }
    .styleBox_06 ul li div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px 35px;
    }
    .styleBox_06 ul li div span {
      font-size: 16px;
      font-weight: 300;
      color: #6f788c;
    }
    .styleBox_06 ul li div img {
      width: 36px;
      height: 36px;
    }
    .styleBox_06 .news_bg {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      min-width: 100%;
      min-height: 345px;
      max-height: 345px;
    }
    .moreService {
      padding: 50px 0 91px;
      display: flex;
      justify-content: center;
    }
    .comButton {
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    }
    .comButton {
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      padding: 0;
      height: 50px;
      font-size: 18px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
  }
}
</style>
<style>
@media only screen and (min-width: 1024px) {
  .tipsInner {
    background-repeat: no-repeat;
    background-size: cover;
    height: 600px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tipsInner .tipsInnerWidth {
    max-width: 1180px;
    margin: 0 auto;
    display: flex;
  }

  .tipsInner .tipsInnerWidth .tipInnerImg {
    margin-right: 95px;
  }

  .tipsInner .tipsInnerWidth .tipInnerImg img {
    width: 530px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText {
    text-align: left;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul {
    display: flex;
    flex-wrap: wrap;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul li {
    width: 40%;
    position: relative;
    font-size: 16px;
    font-weight: 300;
    color: #4c5461;
    margin-bottom: 20px;
    margin-left: 22px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul li::before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: linear-gradient(138deg, #89bcff 0%, #5e70ff 100%);
    border-radius: 5px;
    left: -22px;
    top: 5px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText h4 {
    font-size: 22px;
    font-weight: bold;
    color: #353535;
    line-height: 30px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText .icon_01 {
    width: 36px;
    height: 10px;
    border-radius: 10px;
    background-image: linear-gradient(228deg, #5e70ff, #89bcff 62%);
    margin: 29px 0;
  }

  .tipsInner .tipsInnerWidth .tipInnerText p {
    font-size: 16px;
    color: #353535;
    line-height: 30px;
    font-weight: 300;
    margin-bottom: 30px;
    text-align: left;
  }
  .tipsInner .tipsInnerWidth .tipInnerText .btnBox{
    text-align: right;
  }
}

@media only screen and (max-width: 1024px) {
  .tipsInner {
    background-repeat: no-repeat;
    background-size: cover;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tipsInner .tipsInnerWidth {
    margin: 0 auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 1.875rem;
  }

  .tipsInner .tipsInnerWidth .tipInnerImg {
    margin-right: 95px;
    margin: 0 auto;
    width: 80%;
    margin-bottom: 1rem;
  }

  .tipsInner .tipsInnerWidth .tipInnerImg img {
    width: 100%;
  }

  .tipsInner .tipsInnerWidth .tipInnerText {
    text-align: left;
    width: 80%;
    margin: 0 auto;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul li {
    width: 50%;
    position: relative;
    font-size: 0.875rem;
    font-weight: 300;
    color: #4c5461;
    margin-bottom: 20px;
    text-indent: 1.56rem;
  }

  .tipsInner .tipsInnerWidth .tipInnerText ul li::before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: linear-gradient(138deg, #89bcff 0%, #5e70ff 100%);
    border-radius: 0.5rem;
    left: 0.1rem;
    top: 0.2rem;
  }

  .tipsInner .tipsInnerWidth .tipInnerText h4 {
    font-size: 1.06rem;
    font-weight: bold;
    color: #353535;
    line-height: 30px;
  }

  .tipsInner .tipsInnerWidth .tipInnerText .icon_01 {
    width: 36px;
    height: 10px;
    border-radius: 10px;
    background-image: linear-gradient(228deg, #5e70ff, #89bcff 62%);
    margin: 29px 0;
  }

  .tipsInner .tipsInnerWidth .tipInnerText p {
    font-size: 0.875rem;
    color: #353535;
    line-height: 30px;
    font-weight: 300;
    margin-bottom: 30px;
    text-align: left;
  }
  .tipsInner .tipsInnerWidth .tipInnerText .btnBox{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue